const useChange = (balance: number | null) => {
  let flag;
  if (balance === null) {
    flag = "error";
  }

  const formatChange = (v: number | null): string => {
    if (!v) return "-";
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      signDisplay: "never",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(v);
  };

  if (balance !== null) {
    switch (true) {
      case balance > 0:
        flag = "bullish";
        break;
      case balance < 0:
        flag = "bearish";
        break;
      case balance === 0:
        flag = "neutral";
        break;
      case balance === null:
        flag = "error";
        break;
      default:
        flag = "neutral";
        break;
    }
  }

  return { flag, change: formatChange(balance) };
};

export default useChange;
